(function() {
  "use strict";
  angular.module("irricrops")
    .factory('productividadFac', ["$rootScope", "urls","$http",
        function($rootScope, urls, $http) {

      return {


        //guarda datos del produccion del cuartel
        setCuartel : function(cuartelId, data){
          return $http.post(urls.BASE+'/cuartel/items', {
              cuartel_id: cuartelId,
              datos: data
          });
        },


        //datos del produccion del cuartel
        getCuartel : function(cuartelId){
          return $http.get(urls.BASE+'/cuartel/tabla', {
            params:{
              cuartel_id: cuartelId
            }
          });
        },

        //datos del grafico del cuartel
        getMuestraCuartel : function(produccionId, tipoMuestra){
          return $http.get(urls.BASE+'/cuartel/muestras', {
            params:{
              produccion_id: produccionId,
              tipo_muestra: tipoMuestra
            }
          });
        },

        deleteMuestra : function(muestra){
          return $http.delete(urls.BASE+'/cuartel/muestra/'+muestra.id);
        },

        //datos del grafico del cuartel
        getGraficoCuartel : function(cuartelId){
          return $http.get(urls.BASE+'/cuartel/grafico', {
            params:{
              cuartel_id: cuartelId
            }
          });
        },

        //guarda muestras de un cuartel
        //  [{
        //   "tipo": "poda",
        //   "nombre": "planta 12",
        //   "cantidad": "200",
        //   "hash": "$2y$10$KqJMwyfL9Y0KxmK0YBuvwu9.tAl/9KCjK6Dta/hyFILpB..AfXxQm", opcional
        //   "usar": "true"
        //  },{}]
        saveMuestra : function(cuartelId, data){
          return $http.post(urls.BASE+'/cuartel/muestras', {
              cuartel_id: cuartelId,
              muestras :[data]
          });
        },






        //Datos de produccion del vinedo
        getVinedo : function(vinedoId){
          return $http.get(urls.BASE+'/vinedo/produccion', {
            params:{
              vinedo_id : vinedoId
            }
          });
        },


      };

    }]);
})();
